<kendo-dialog
	title="Training Activity"
	*ngIf="dialogOpened"
	(close)="close('dialog')"
	[minWidth]="250"
	[width]="350">
	<div>
		<button
			class="doc-download wrap-btn"
			kendoButton
			[title]="documentTitle"
			[svgIcon]="hyperlinkOpenIcon"
			(click)="openLink(linkUrl)">
			{{ documentTitle }}
		</button>
	</div>
	<div>Please click the link to start training and select I agree when completed.</div>
	<kendo-dialog-actions>
		<button
			kendoButton
			kpaKendoButton="secondary"
			(click)="close('dialog')">
			Cancel</button
		>&nbsp;
		<button
			kendoButton
			[ngClass]="!isReadDocEnabled ? 'disabled-button' : 'primary-button'"
			(click)="completeTraining(documentId)">
			I Agree
		</button>
	</kendo-dialog-actions>
</kendo-dialog>
